import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DataResult } from '@progress/kendo-data-query';
import { map, Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { appendQuery } from 'src/app/shared/utilities/route';
import { FetchArgs } from 'src/app/shared/models/core';
import { IntegrationMapping } from '../models/integration-mapping.model';

@Injectable({
    providedIn: 'root'
})
export class IntegrationMappingsService {
    constructor(private readonly _httpClient: HttpClient, @Inject(APP_CONFIG) private readonly _settings: Settings) {}

    getAllIntegrationMappings(args: FetchArgs): Observable<DataResult> {
        let url = `${this._settings.coreAPIUrl}ayanova/integrations/mappings`;
        for (const prop in args?.filter) {
            if (Object.prototype.hasOwnProperty.call(args?.filter, prop)) {
                url = appendQuery(url, `${prop}=${args?.filter[prop]}`);
            }
        }

        url = appendQuery(url, `skip=${args.skip}`);
        url = appendQuery(url, `pageSize=${args.pageSize}`);

        return this._httpClient.get<IntegrationMapping[]>(url).pipe(
            map((res) => {
                return {
                    data: res,
                    total: res?.length ?? 0
                };
            })
        );
    }

    add(mapping: IntegrationMapping): Observable<IntegrationMapping> {
        const url = `${this._settings.coreAPIUrl}ayanova/integrations/mappings`;
        return this._httpClient.post<IntegrationMapping>(url, mapping);
    }

    update(mapping: IntegrationMapping): Observable<IntegrationMapping> {
        const url = `${this._settings.coreAPIUrl}ayanova/integrations/mappings`;
        return this._httpClient.put<IntegrationMapping>(url, mapping);
    }

    delete(id: number): Observable<any> {
        const url = appendQuery(`${this._settings.coreAPIUrl}ayanova/integrations/mappings`, `id=${id}`);
        return this._httpClient.delete(url);
    }
}
